import Tooltip from '@material-ui/core/Tooltip';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import { SVGPrice } from 'constants/SVG';
import { formatCurrency } from 'utils/FormatNumber';
import styles from './styles.module.css';

const DiscountIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <g clipPath="url(#clip0_6866_58618)">
      <path
        d="M22.8965 12.5008L23.9494 9.75453C24.0649 9.45155 23.9749 9.10807 23.7214 8.90259L21.4386 7.05171L20.9766 4.14641C20.9256 3.82543 20.6736 3.57495 20.3527 3.52396L17.4474 3.06199L15.598 0.777643C15.394 0.52416 15.043 0.434166 14.7475 0.549658L11.9997 1.60409L9.25342 0.551158C8.94894 0.434166 8.60846 0.52716 8.40298 0.779143L6.5521 3.06349L3.6468 3.52545C3.32732 3.57645 3.07534 3.82843 3.02434 4.14791L2.56238 7.05322L0.278033 8.90409C0.0260501 9.10807 -0.0654437 9.45155 0.0500484 9.75453L1.10298 12.5008L0.0500484 15.2472C-0.0669436 15.5501 0.0260501 15.8936 0.278033 16.0976L2.56238 17.947L3.02434 20.8523C3.07534 21.1733 3.32582 21.4252 3.6468 21.4762L6.5521 21.9382L8.40298 24.221C8.60846 24.476 8.95194 24.566 9.25492 24.449L11.9997 23.3976L14.746 24.4505C14.833 24.4835 14.923 24.5 15.0145 24.5C15.235 24.5 15.4525 24.4025 15.598 24.221L17.4474 21.9382L20.3527 21.4762C20.6736 21.4252 20.9256 21.1733 20.9766 20.8523L21.4386 17.947L23.7214 16.0976C23.9749 15.8921 24.0649 15.5501 23.9494 15.2472L22.8965 12.5008Z"
        fill="#D4323B"
      />
      <path
        d="M9.74985 11.0008C8.50943 11.0008 7.5 9.99136 7.5 8.75095C7.5 7.51053 8.50943 6.5011 9.74985 6.5011C10.9903 6.5011 11.9997 7.51053 11.9997 8.75095C11.9997 9.99136 10.9903 11.0008 9.74985 11.0008ZM9.74985 8.001C9.33587 8.001 8.9999 8.33697 8.9999 8.75095C8.9999 9.16492 9.33587 9.50089 9.74985 9.50089C10.1638 9.50089 10.4998 9.16492 10.4998 8.75095C10.4998 8.33697 10.1638 8.001 9.74985 8.001Z"
        fill="#FAFAFA"
      />
      <path
        d="M14.2498 18.5004C13.0094 18.5004 12 17.491 12 16.2506C12 15.0102 13.0094 14.0007 14.2498 14.0007C15.4903 14.0007 16.4997 15.0102 16.4997 16.2506C16.4997 17.491 15.4903 18.5004 14.2498 18.5004ZM14.2498 15.5006C13.8374 15.5006 13.4999 15.8381 13.4999 16.2506C13.4999 16.6631 13.8374 17.0005 14.2498 17.0005C14.6623 17.0005 14.9998 16.6631 14.9998 16.2506C14.9998 15.8381 14.6623 15.5006 14.2498 15.5006Z"
        fill="#FAFAFA"
      />
      <path
        d="M8.24928 18.5004C8.09779 18.5004 7.9463 18.4554 7.81431 18.3609C7.47683 18.1194 7.39884 17.6514 7.64032 17.314L15.1398 6.81468C15.3813 6.4772 15.8493 6.3992 16.1867 6.64069C16.5242 6.88067 16.6007 7.35014 16.3607 7.68612L8.86124 18.1854C8.71275 18.3909 8.48326 18.5004 8.24928 18.5004Z"
        fill="#FAFAFA"
      />
    </g>
    <defs>
      <clipPath id="clip0_6866_58618">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5ZM13.1429 7.92857C13.1429 8.55975 12.6312 9.07143 12 9.07143C11.3688 9.07143 10.8571 8.55975 10.8571 7.92857C10.8571 7.29739 11.3688 6.78571 12 6.78571C12.6312 6.78571 13.1429 7.29739 13.1429 7.92857ZM12 11.0714C12.4734 11.0714 12.8571 11.4552 12.8571 11.9286V17.6429C12.8571 18.1162 12.4734 18.5 12 18.5C11.5266 18.5 11.1429 18.1162 11.1429 17.6429V11.9286C11.1429 11.4552 11.5266 11.0714 12 11.0714Z"
      fill="#0E1983"
    />
  </svg>
);

const CustomTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#EBEFFA',
    filter: 'drop-shadow(0px 1px 1px rgba(25, 43, 79, 0.20))'
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#EBEFFA',
    color: '#353FA5',
    fontSize: 14,
    top: '4px',
    padding: '12px',
    maxWidth: '380px',
    boxShadow: '0px 2px 10px 0px rgba(25, 43, 79, 0.20)',
  },
}));


const PriceAfterDiscount = ({ retailPriceApplyVoucher, isCart = false }) => {
  if (isCart) {
    return (
      <CustomTooltip
        arrow
        placement="top"
        title={
          (
            <span>
              Đây là giá đã giảm sau khi áp dụng các chương trình khuyến mãi như <span className={styles?.boldColor}> Chiết khấu chuyển khoản</span> và{' '}
              <span className={styles?.boldColor}>Mã giảm giá</span>
            </span>
          )
        }
      >
        <div className={styles?.cartPriceContainer}>
          <span className={styles?.cartPriceDiscount}>
            <span className={styles?.cartLabelDiscountPrice}>
              Giá sau chiết khấu
            </span>
            <SVGPrice displayPriceFormated={formatCurrency(retailPriceApplyVoucher)} fillPath="#D4323B" size="mdx" />
          </span>


        </div>
      </CustomTooltip>
    )
  }

  return (
    <div className={styles?.priceContainer}>
      <DiscountIcon />
      <span className={styles?.priceDiscount}>
        Giá sau chiết khấu
        <SVGPrice displayPriceFormated={formatCurrency(retailPriceApplyVoucher)} fillPath="#D4323B" size="mdn" />
      </span>

      <CustomTooltip
        arrow
        placement="top"
        title={(
          <span>
            Bạn có thể mua được giá này khi thanh toán bằng hình thức <span className={styles?.boldColor}>Chuyển khoản</span> và sử dụng{' '}
            <span className={styles?.boldColor}>Mã giảm giá</span>
          </span>
        )}
      >
        <div className={styles?.wrapperIcon}>
          <InfoIcon />
        </div>
      </CustomTooltip>
    </div>
  );
};

export default PriceAfterDiscount;
